// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './Page';
import { default as http } from './plugins/http';
import VueBus from 'vue-bus';
import store from './store';
import Tracking from './tracking';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
import './style/element-variables.scss';
import i18n from './lang';
import './style/custom.scss';
import './style/reset.sass';
import '@/assets/iconfont/iconfont.css';
// 字体样式
// import './style/font.scss'
import Vuebar from './plugins/vuebar';
import handleAssetsUrl from './plugins/handleAssetsUrl';
import chartFromJson from './plugins/chartFromJson';
import util from './plugins/util';
import directive from './plugins/directive';
import icon from './components/common/icon.vue';
import VueQriously from 'vue-qriously';
import * as qss from 'qss';
import sensors from './sensorsIndex';
import VueLazy from 'vue-lazyload';
import memberGuide from './plugins/memberGuide';
import VModal from 'vue-js-modal'
// "@laipic/webui": "^1.2.2-2",
// import webui from '@laipic/webui';
// require('./plugins/sortable.js')
const VDragged = require('./plugins/v-dragged').VDragged;
// import VModal from './plugins/vue-js-modal/index'
// const VModal = require('./plugins/vue-js-modal').default;

const QI_NIU = 'https://resources.laihua.com';
const lazyLoadImg =  require('../static/img/lazy-loading.svg');

// 生成二维码
Vue.use(VueQriously);
Vue.use(VueLazy, {
  error: lazyLoadImg,
  loading: lazyLoadImg
});
Vue.use(Vuebar);
Vue.use(handleAssetsUrl, {
  base: QI_NIU
});
Vue.use(util);
Vue.use(directive);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(chartFromJson);
Vue.use(VDragged);
Vue.use(VModal);
Vue.use(VueBus); // 全局事件中心
// Vue.use(webui);

// tooltip

Vue.config.productionTip = false;

// Vue prototype
Vue.prototype.$http = Vue.prototype.$axios = http;
Vue.prototype.$qs = qss;
Vue.prototype.$tracking = new Tracking(store);
Vue.prototype.$memberGuide = memberGuide;
Vue.prototype.$getWikiLink = (key) => {
  let map = {
    'https://wiki.laihua.com/basic/wenziyun/wenziyun.html': 'https://support.qq.com/products/408104/faqs/121723',
    'https://wiki.laihua.com/basic/useraccount/payProblem.html':	'https://support.qq.com/products/408104/faqs/121185',
    'https://wiki.laihua.com/basic/ppt/ppt.html':	'https://support.qq.com/products/408104/faqs/119579',
    'https://wiki.laihua.com/basic/shijianzhou/shijianzhou.html':	'https://support.qq.com/products/408104/faqs/121725',
    'https://wiki.laihua.com/shouquan/shouquan.html':	'https://support.qq.com/products/408104/faqs/121194',
    'https://wiki.laihua.com/whatsnew/whatsnew.html':	'https://support.qq.com/products/408104/',
    'commercial': 'https://support.qq.com/products/408104/faqs-more?id=121192'
  }
  return map[key] || key;
}
window.sensors = sensors;

function GetRequest() { // url参数提取
  var url = window.location.search; // 获取url中"?"符后的字串
  var theRequest = new Object();

  if (url.indexOf('?') != -1) {
    var strs = url.substr(1);
    strs = strs.split('&');
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }
  return theRequest;
}

function AhandleAssetsUrl(url) { // auto-draw相关函数
  if (!url) return '';
  var reg = /^\//;
  // var qiniuAssetsUrl = 'http://www.laihua.com';
  var qiniuAssetsUrl = 'https://resources.laihua.com';

  var reg2 = new RegExp(qiniuAssetsUrl + '/', 'g');
  url = url.replace(reg2, '');
  // var qiniuAssetsUrl = '';
  if (!reg.test(url)) {
    return qiniuAssetsUrl + '/' + url;
  } else {
    return qiniuAssetsUrl + url;
  }
}

Vue.prototype.$bc = new BroadcastChannel('laihua');
Vue.prototype.$route = GetRequest();
Vue.prototype.$fetch = function (url, option) { // auto-draw相关函数
  url = AhandleAssetsUrl(url);
  return fetch(url, option).then(function (resp) {
    if (resp.status >= 200 && resp.status < 300) {
      return resp;
    } else {
      throw resp.statusText;
    }
  })
    .catch(function (err) {
    });
};

Vue.prototype.$isEditableShape = (fileType) => {
  return fileType == 28;
};

Vue.prototype.$isEditableLine = (fileType) => {
  return fileType == 29;
};

Vue.prototype.$isEditableSvg = (fileType) => {
  return fileType == 28 || fileType == 29;
};



Vue.component('icon', icon);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  components: { App, icon },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js